import { apiSpiderMapBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const stopApiRoutes = {
    list: apiSpiderMapBaseURL + "stops/",
};

export class StopAPI {
    static list() {
        const url = `${stopApiRoutes.list}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/spidermap/StopAPI.js